import { useGlobalConfigContext } from 'GlobalConfig.context';
import LoadingDots from 'components/LoadingDots';
import { useDropOffLocationContainer } from './useDropOffLocationContainer';
import { DropOffLocationDetails } from '../DropOffLocationDetails';
import { ViewAvailableDropOffLocationContainer } from '../../ViewAvailableDropOffLocations';

interface IDropOffLocationContainerProps {
  shipmentPk: number;
  carrierId: string;
}

export const DropOffLocationContainer = ({
  shipmentPk,
  carrierId,
}: IDropOffLocationContainerProps) => {
  const { organizationId } = useGlobalConfigContext();
  const { data, isLoading } = useDropOffLocationContainer(
    organizationId,
    shipmentPk,
  );

  if (isLoading) {
    return <LoadingDots />;
  }

  // If there are a drop-off location datas known: show map and drop off location details (mandatory UI)
  // If there is no drop-off location: show “drop off optional UI” (ATM-48)
  if (!data) {
    return <ViewAvailableDropOffLocationContainer carrierId={carrierId} />;
  }

  return <DropOffLocationDetails data={data} />;
};
